import accordion from './accordion.vue';

export default  {
    accordion
};
